<span class="loading-content">
  <div class="leftFloat"><mat-spinner [diameter]="25"></mat-spinner></div>
  <div class="spinner-text"> Loading...</div>
</span>
